import application from 'application/application';

const controller = 'DefaultPublicationsSubmenuController';

application

	.controller(controller, ['$scope', ($scope) => {

		$scope.formAddKeywordStage = 1;

		$scope.formAddKeywordNextStage = () => $scope.formAddKeywordStage++;

		$scope.formAddKeywordPrevStage = () => $scope.formAddKeywordStage--;

	}]);

export default controller;
